import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MastheadLogoAPI = /*#__PURE__*/function () {
  function MastheadLogoAPI() {
    _classCallCheck(this, MastheadLogoAPI);
  }

  _createClass(MastheadLogoAPI, null, [{
    key: "setMastheadLogo",

    /**
     * Determines whether to return custom or default IBM logo
     *
     * @returns {boolean} Use alternate logo or not
     *
     * @example
     * import { MastheadLogoAPI } from '@carbon/ibmdotcom-services';
     *
     * const useAlternateLogo = MastheadLogoAPI.setMastheadLogo(logoData);
     */
    value: function setMastheadLogo(logoData) {
      if (logoData === undefined) return false;
      var currentTime = new Date().getTime();
      var expireTime = logoData.end ? Date.parse(logoData.end) : null;
      var isExpired = expireTime && currentTime > expireTime ? true : false;

      if (logoData.svg === null || isExpired || logoData.denylist && logoData.denylist.indexOf(location.pathname) !== -1) {
        return false;
      } else if (logoData.allowlist && (logoData.allowlist.length == 0 || logoData.allowlist.indexOf(location.pathname) !== -1) && logoData.svg) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return MastheadLogoAPI;
}();

export default MastheadLogoAPI;